import React from 'react';

import moment from 'moment';
import { Link } from 'react-router-dom';

import Alert from '../../../../../Alert';

const generateSettlementDatesString = (settlements) => {
  return settlements
    .map((settlement, index) => {
      const isLast = index === settlements.length - 1;
      return `${
        settlement.date ? moment(settlement.date).format('M/D/YY') : ''
      }${!isLast ? ' and ' : ''}`;
    })
    .join('');
};

export default function SettlementArray({ billPayment }) {
  const shouldShowSettlementAlert =
    billPayment && billPayment?._billcom_settlements?.length;

  if (!shouldShowSettlementAlert) {
    return null;
  }

  const message =
    billPayment._billcom_settlements?.length === 1
      ? `This bill payment settled on ${
          billPayment._billcom_settlements[0].date
            ? moment(billPayment._billcom_settlements[0].date).format('M/D/YY')
            : ''
        }`
      : `This bill payment settled on ${generateSettlementDatesString(
          billPayment._billcom_settlements
        )}`;

  return (
    <div className="mb-4">
      <Alert
        message={
          <>
            {message}.{' '}
            <Link
              to={`/billcom-settlements/${billPayment?._billcom_settlements?.[0]?.billcom_settlement_parent_id}`}
              className="underline"
            >
              View details
            </Link>
          </>
        }
      />
    </div>
  );
}
